// extracted by mini-css-extract-plugin
export default {"downloadBtn":"FileViewerDrawer_downloadBtn__NmTQk","previewDrawer":"FileViewerDrawer_previewDrawer__ZeofS","previewBody":"FileViewerDrawer_previewBody__Lcj3o"};